import {
    Component,
    EventEmitter,
    Input,
    Output,
    TemplateRef,
} from '@angular/core';

import {
    CmpsCardRowData,
    CmpsCardRowMenuData,
    CmpsCardRowProgressData,
    RowType,
    TrendType,
} from './card-data-row.model';
@Component({
    selector: 'cmps-card-data-row',
    template: `
        <div
            class="cmps-card-data-row-container"
            [ngClass]="{
                'cmps-card-data-row-container-clickable': isClickable()
            }"
            (click)="
                isClickable() ? rowClickAction.emit(rowData.rowType) : null
            "
        >
            <div class="cmps-card-data-row--column">
                <div class="cmps-card-data-row--label">
                    <span>{{ rowData.dataRowNameLabel }}</span>
                </div>
            </div>
            <ng-container *ngIf="rowData.noDataLabel; else rowDataTemplate">
                <div class=" cmps-card-data-row--column">
                    <span>{{ rowData.noDataLabel }}</span>
                </div>
            </ng-container>
            <ng-template #rowDataTemplate>
                <div class="cmps-card-data-row--column">
                    <div
                        class="cmps-card-data-row--triangle"
                        [cmpsTooltipTrigger]="menuTooltipContent"
                        placement="top-center"
                    >
                        <span>{{ rowData.percentageValue }}</span>
                        <ng-container [ngSwitch]="rowData.trendId">
                            <cmps-icon
                                *ngSwitchCase="trendType.UP"
                                svgIcon="__internal:trend-up"
                                [style.fill]="rowData.trendColor"
                            ></cmps-icon>
                            <cmps-icon
                                *ngSwitchCase="trendType.DOWN"
                                svgIcon="__internal:trend-down"
                                [style.fill]="rowData.trendColor"
                            ></cmps-icon>
                            <cmps-icon
                                *ngSwitchCase="trendType.NEUTRAL"
                                svgIcon="__internal:trend-neutral"
                                [style.fill]="rowData.trendColor"
                            ></cmps-icon>
                            <span *ngSwitchDefault>{{
                                rowData.placeholderStr
                            }}</span>
                        </ng-container>
                    </div>

                    <ng-template #menuTooltipContent>
                        <div
                            class="cmps-card-data-row-tooltip-content"
                            *ngFor="let i of rowData.menuTooltipData"
                        >
                            <div
                                class="cmps-card-data-row-tooltip-content-child"
                            >
                                <strong>{{ i.label }}</strong>
                            </div>
                            <div
                                class="cmps-card-data-row-tooltip-content-child"
                            >
                                {{ i.value }}
                            </div>
                        </div>
                    </ng-template>
                </div>

                <div class="cmps-card-data-row--column">
                    <div
                        class="cmps-card-data-row--progress-bar"
                        [cmpsTooltipTrigger]="progressTooltipContent"
                        placement="top-center"
                    >
                        <div
                            class="cmps-card-data-row--progress-bar-filled"
                            *ngFor="let i of progressData.progressBarValues"
                            [style.width]="i.thresholdValue"
                        >
                            <div
                                class="cmps-card-data-row--progress-bar-filled-child"
                                [style.backgroundColor]="i.opportunityColor"
                                [style.width]="i.actualValue"
                            ></div>
                        </div>
                    </div>
                    <ng-template #progressTooltipContent>
                        <div
                            class="cmps-card-data-row-tooltip-content"
                            *ngFor="let i of progressData.progressTooltipData"
                        >
                            <div
                                class="cmps-card-data-row-tooltip-content-child"
                            >
                                <strong>{{ i.label }}</strong>
                            </div>
                            <div
                                class="cmps-card-data-row-tooltip-content-child"
                            >
                                {{ i.value }}
                            </div>
                        </div>
                    </ng-template>
                </div>
                <div class="cmps-card-data-row--column">
                    <ng-container
                        *ngTemplateOutlet="trendButtonTemplate"
                    ></ng-container>
                </div>
                <div
                    class="cmps-card-data-row--column cmps-card-data-row--column--button"
                    *ngIf="
                        rowData.rowType !== rowType.MI2 &&
                        rowData.rowType !== rowType.FLOA
                    "
                >
                    <div
                        class="cmps-card-data-row--dots"
                        *ngIf="rowData.rowType === rowType.OA"
                    >
                        <cmps-icon svgIcon="__internal:dots"></cmps-icon>

                        <div
                            class="cmps-card-data-row-menu"
                            *ngIf="dropdownMenuData.dropdownMenuValues"
                        >
                            <ng-container
                                *ngFor="
                                    let i of dropdownMenuData.dropdownMenuValues
                                "
                            >
                                <div
                                    class="cmps-card-menu-item"
                                    [ngClass]="{
                                        'cmps-card-menu-item--selected':
                                            i.selected
                                    }"
                                    (click)="
                                        $event.stopPropagation();
                                        selectedAction.emit(i)
                                    "
                                >
                                    <cmps-icon
                                        *ngIf="i.selected"
                                        svgIcon="__internal:check"
                                    ></cmps-icon>
                                    <span class="cmps-card-menu-item--label">{{
                                        i.value
                                    }}</span>
                                    <cmps-icon
                                        *ngIf="i.subMenu"
                                        svgIcon="__internal:chevron-right"
                                    ></cmps-icon>
                                    <div
                                        class="cmps-card-sub-menu"
                                        *ngIf="i.subMenu"
                                    >
                                        <ng-container
                                            *ngFor="let j of i.subMenu"
                                        >
                                            <div
                                                class="cmps-card-menu-item cmps-card-sub-menu-item"
                                                [ngClass]="{
                                                    'cmps-card-sub-menu-item--selected':
                                                        j.selected
                                                }"
                                                (click)="
                                                    $event.stopPropagation();
                                                    selectedAction.emit(j)
                                                "
                                            >
                                                <div *ngIf="j.selected">
                                                    <cmps-icon
                                                        svgIcon="__internal:check"
                                                    ></cmps-icon>
                                                </div>
                                                <span>{{ j.value }}</span>
                                            </div>
                                        </ng-container>
                                    </div>
                                </div>
                            </ng-container>
                        </div>
                    </div>
                    <div
                        class="cmps-card-data-row--close-button"
                        *ngIf="rowData.rowType === rowType.OA_CHILD"
                    >
                        <button
                            class="cmps-icon-button--no-bg"
                            (click)="closeAction.emit($event)"
                        >
                            <cmps-icon svgIcon="__internal:close"></cmps-icon>
                        </button>
                    </div>
                </div>
            </ng-template>
        </div>
    `,
    host: {
        class: 'cmps-card-data-row',
        '[class.cmps-card-data-row--without-data]': 'rowData.noDataLabel',
    },
})
export class CmpsCardDataRowComponent {
    @Input() rowData: CmpsCardRowData;
    @Input() trendButtonTemplate: TemplateRef<any> | null;
    @Input() progressData: CmpsCardRowProgressData;
    @Input() dropdownMenuData: CmpsCardRowMenuData;

    @Output() selectedAction: EventEmitter<MouseEvent | KeyboardEvent>;
    @Output() closeAction: EventEmitter<MouseEvent | KeyboardEvent>;
    @Output() rowClickAction: EventEmitter<RowType>;
    rowType = RowType;
    trendType = TrendType;

    constructor() {
        this.closeAction = new EventEmitter();
        this.selectedAction = new EventEmitter();
        this.rowClickAction = new EventEmitter();
    }

    ngOnDestroy(): void {
        this.closeAction.complete();
        this.selectedAction.complete();
        this.rowClickAction.complete();
    }

    isClickable(): boolean {
        return this.rowData.rowType !== this.rowType.OA_CHILD;
    }
}
